import { render } from "./MobileNavBar.vue?vue&type=template&id=2374e5d9&scoped=true"
import script from "./MobileNavBar.vue?vue&type=script&lang=js"
export * from "./MobileNavBar.vue?vue&type=script&lang=js"

import "./MobileNavBar.vue?vue&type=style&index=0&id=2374e5d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2374e5d9"]])

export default __exports__